<template>
    <div>
        <div v-if="$utils.have('/event/conversionRate/save')" class="page-btns-box">
            <el-button type="primary" size="small" @click="$refs.edit.show()">新增事件转化率报表</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column label="目标事件">
                    <template slot-scope="{row} = scope">
                        <div>名称：{{ row.lastEventName }}</div>
                        <div>标识：{{ row.lastEventId }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="stepsNum" label="步骤数"></el-table-column>
                <el-table-column label="最近7天转化率">
                    <template slot-scope="{row} = scope">
                        <div>次数：{{ row.pvRate }}</div>
                        <div>人数：{{ row.uvRate }}</div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="{row} = scope">
                        <el-button type="text" size="small"
                            @click="$router.push({ path: '/eventManage/conversionRate/statistic/' + row.id })">统计</el-button>
                        <el-button v-if="$utils.have('/event/conversionRate/save')" type="text" size="small"
                            @click="$refs.edit.show(row.id)">编辑</el-button>
                        <el-button type="text" size="small" @click="del(row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <edit ref="edit" @onUpdate="getDataList"></edit>
    </div>
</template>
<script>
import Edit from './components/Edit';
const defaultParams = {
    pageNo: 1,
}
export default {
    components: {
        Edit
    },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
            },
            listLoading: true,
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/event/conversionRate/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.data = null;
                        this.dataList = [];
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //删除
        del(id) {
            this.$confirm('是否确认删除？删除后不可恢复', '提示', {
                confirmButtonText: '确认删除',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.$request({
                    url: "/event/conversionRate/delete",
                    method: "POST",
                    params: {
                        id: id
                    }
                }).then(res => {
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$message.success("删除成功");
                        this.getDataList()
                    } else {
                        return this.$message.error(msg || "删除失败");
                    }
                })
            }).catch(() => { })
        },
    }
}
</script>
<style lang="scss" scoped></style>